import { Order, ShipmentInfo } from '@/apis/order/interface';
import { formatPhoneDefault, trimAndFormatAnyContact } from '@/utils/form';
import { isEmpty } from '@/utils/validate';

export const parseOrderDetail = (order: Order) => {
  return {
    ...order,
    shipmentInfo: getShipmentInfo(order)
  };
};

export type OrderModel = ReturnType<typeof parseOrderDetail>;

const getShipmentInfo = (order: Order) => {
  if (!order.shipmentInfo) return null;
  if (isShipmentAlmostEmpty(order.shipmentInfo)) return null;

  return {
    customerServiceTel: trimAndFormatAnyContact(
      order.shipmentInfo.customerServiceTel
    ),
    operationInfo: order.shipmentInfo.operationInfo ?? [],
    riderName: order.shipmentInfo.riderName,
    riderPhone: trimAndFormatAnyContact(order.shipmentInfo.riderPhone),
    shippingCompanyName: order.shipmentInfo.shippingCompanyName,
    trackingId: order.shipmentInfo.trackingId
  };
};

const isShipmentAlmostEmpty = (shipment: ShipmentInfo) => {
  const entriesExceptShippingCompanyName = Object.entries(shipment).filter(
    ([key]) => key !== 'shippingCompanyName' && key !== 'trackingId'
  );

  const doesntHaveAnyOtherProperty = !entriesExceptShippingCompanyName?.length;
  const everyKeyEmpty = entriesExceptShippingCompanyName?.every(
    ([key, value]) => isEmpty(value)
  );
  return doesntHaveAnyOtherProperty || everyKeyEmpty;
};
